// React
import React, { Component } from "react";

// Libraries
import Numeral from 'numeral';

// Panel
import { PanelHeading, PanelBody } from '../../Components';

// Stores
import { UserProfileStore, SampleDataStore, CurrencyStore } from '../../Stores';

import { ErrorHandler } from '../../Utils';

// Styles
import "./dashboard-flex.css";

class Orders extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {

            orders : {},
            arrowClass : 'icon-arrow-up8 green-text',
            description : ["All of your open orders, with relevant information such as the leverage and total value."],
            loading : true,
            message : null
        };

    }


/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        //console.log('Orders.componentDidMount()');

        // If user logged in, fetch the orders
        if(this.props.user !== null) {
            this.getOrders(false);
        }
        else {
            this.getSampleOrders();
        }

    }

/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Retrieves the orders from UserProfileStore
    getOrders(refresh) {

        //console.log('Orders.getOrders()');
    
        UserProfileStore.getOrders(refresh)
            .then( (orders) => {

                var newOrders = this.flattenOrders(orders);

                var message = null;

                if(Object.keys(newOrders).length === 0) {
                    message = {
                        title : 'No Open Orders',
                        details : 'Looks like a nice day to do some trading..',
                        type : ''
                    }
                }

                this.setState((prev, props) => {
                    return {
                        loading : false,
                        orders : newOrders,
                        message : message
                    }
                });

            }).catch( (error) => {

                var errorMessage = ErrorHandler.parseError('orders', error);

                this.setState((prev, props) => {
                    return {
                        loading : false,
                        message : errorMessage
                    }
                });

            });

    }


    // Flattens the orders into a single level object
    flattenOrders(exchanges) {

        var orders = {};

        for(let [exchange, details] of Object.entries(exchanges)) {

            if(details.success && Object.keys(details.data).length > 0) {

                for(let [id, order] of Object.entries(details.data)) {

                    order.exchange = exchange;
                    order.symbol = CurrencyStore.getCurrencySymbol(order.quoteCurrency)

                    orders[id] = order;
                }

            }
            
        }

        return orders;

    }


    // Gets and displays the sample data orders
    getSampleOrders() {

        const orders = this.flattenOrders(SampleDataStore.getOrderData());
        
        this.setState((prev, props) => {
            return {
                loading : false,
                orders : orders
            }
        });

    }


    // Retrieves the latest orders
    refreshOrders() {

        this.getOrders(true);

        this.setState((prev, props) => {
            return {
                loading : true
            }
        });

    }


    buildOrders(orders) {

        return (

            Object.entries(orders).map( ([id, order]) => {

                return (

                    <div className="flex-panel" key={id}>

                        <div className="child-row">

                            <div className="row-box left">

                                <div>
                                    { order.type } 
                                    <span className="label label-flat label-info left-pad">{ order.leverage }:1</span>
                                </div>

                                <div className="lowlight"> 
                                    { order.exchange } 
                                </div>

                            </div>

                            <div className="column-box left">

                                <div>
                                    <i className={ order.type === "buy" ? 'icon-sort green-text right-pad' : 'icon-sort red-text right-pad'}></i>
                                </div>

                                <div className="row-box left">
                                    <div>{ order.baseCurrency }</div>
                                    <div> { order.quoteCurrency } </div>
                                </div>

                            </div>

                            <div className="row-box right">

                                <div>
                                    { 
                                        order.volume > 1 ? 
                                        Numeral(order.volume).format(CurrencyStore.getDecimalsFormat(2)) : 
                                        Numeral(order.volume).format(CurrencyStore.getFormat(order.baseCurrency)) 
                                    }
                                </div>

                                <div>
                                    <span className="right-pad">{ order.symbol }</span>
                                    { order.price > 1 ? 
                                        Numeral(order.price).format(CurrencyStore.getDecimalsFormat(2)) : 
                                        Numeral(order.price).format(CurrencyStore.getFormat(order.quoteCurrency)) 
                                    } 
                                </div>

                            </div>

                            <div className="row-box right">

                                <div>Total </div>

                                <div> 
                                    <span className="right-pad">{order.symbol}</span>
                                    { 
                                        order.total > 1 ? 
                                        Numeral(order.total).format(CurrencyStore.getDecimalsFormat(2)) : 
                                        Numeral(order.total).format(CurrencyStore.getFormat(order.quoteCurrency)) 
                                    } 
                                </div>

                            </div>

                        </div>
                        
                    </div>
                )

            })

        )
    }

/**********************************************************
 *  Render
 **********************************************************/

  render() {

    //console.log('Orders.render()');

    return (

        <div className="panel panel-flat bg-theme-700">

            <PanelHeading title={"Open Orders"} description={this.state.description} 
                sample={this.props.user === null ? true : false} 
                refresh={this.props.user === null ? null : this.refreshOrders.bind(this)}>
            </PanelHeading>

            <PanelBody loading={this.state.loading} message={this.state.message}>

                <div className="row">
                    { this.buildOrders(this.state.orders) }
                </div>

            </PanelBody>

        </div>

    );
  }
}

export default Orders;



// WEBPACK FOOTER //
// ./src/Views/Dashboard/Orders.js